import {FC, ReactNode} from "react";
import {css, cx} from "@pandacss/css";
import {font} from "../style/typography.tsx";
import {useNavigate} from "react-router";

interface Props {
    to?: string
    onClick?: () => void
    children: ReactNode
}

const navigationItemClass = css({
    cursor: 'pointer'
});

const activeClass = css({
    color: 'primary.200'
})

const NavigationItem: FC<Props> = ({to, children, onClick}) => {
    const navigate = useNavigate();
    const active = !!to && window.location.pathname.startsWith(to);

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (to) {
            navigate(to);
        }
    }

    return <div className={cx(navigationItemClass, font('heading', '4', 'bold'), active ? activeClass : '')} onClick={handleClick}>{children}</div>
}

export default NavigationItem